import { FC, useMemo } from 'react';

interface LeaveOverlapNoticeProps {
  dates: Date[];
  title: string;
}

const formatDay = (d: Date) => d.toLocaleDateString(undefined, { weekday: 'short', day: 'numeric', month: 'short' });

const isNextDay = (a: Date, b: Date) =>
  new Date(a.getFullYear(), a.getMonth(), a.getDate() + 1).getTime() ===
  new Date(b.getFullYear(), b.getMonth(), b.getDate()).getTime();

const toRanges = (dates: Date[]): string[] => {
  const ranges: string[] = [];
  let i = 0;
  while (i < dates.length) {
    let j = i;
    while (j + 1 < dates.length && isNextDay(dates[j], dates[j + 1])) j++;
    ranges.push(i === j ? formatDay(dates[i]) : `${formatDay(dates[i])} – ${formatDay(dates[j])}`);
    i = j + 1;
  }
  return ranges;
};

export const LeaveOverlapNotice: FC<LeaveOverlapNoticeProps> = ({ dates, title }) => {
  const ranges = useMemo(() => toRanges(dates), [dates]);
  if (dates.length === 0) return null;

  return (
    <div className="rounded border border-red-300 bg-red-50 p-3 text-sm text-red-600">
      <p className="font-semibold">{title}</p>
      <ul className="mt-1 list-disc pl-5">
        {ranges.map(range => (
          <li key={range}>{range}</li>
        ))}
      </ul>
    </div>
  );
};
